var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFullPatternMobile = function SvgFullPatternMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 303,
    viewBox: "0 0 360 303",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.983 -253.922C160.411 -198.494 208.489 -246.572 263.917 -191.144C319.344 -135.716 271.267 -87.6381 326.695 -32.2101C382.123 23.2178 430.201 -24.8599 485.628 30.568C541.056 85.9959 492.979 134.074 548.407 189.502L435.424 302.485C379.996 247.057 428.074 198.979 372.646 143.551C317.218 88.1229 269.14 136.201 213.712 80.7727C158.284 25.3448 206.362 -22.7332 150.934 -78.1611C95.5057 -133.589 47.4277 -85.5114 -8.00018 -140.939L104.983 -253.922Z",
    fill: "#FFF7E5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFullPatternMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FullPatternMobile.d9a1b57a.svg";
export { ForwardRef as ReactComponent };